export default "__VITE_ASSET__U$Jzh7j3__"